import React from 'react';

import { Button, Col, Row } from 'antd';
import { NextPage } from 'next';
import { FormattedMessage } from 'react-intl';

interface OwnProps {
  leftComponent: React.ReactNode;
  rightComponent: React.ReactNode;
  showRight: boolean;
}

export const ToggleButtons = (
  onRestore: any,
  onAccept: any,
  loading?: boolean
) => {
  return (
    <Row
      className="toggle-contents-buttons"
      justify="space-between"
      align="middle"
    >
      <Col className="toggle-column toggle-column--left toggle-column--over">
        <Button
          className="btn-primary"
          block
          onClick={onRestore}
          disabled={loading}
        >
          <Row justify="space-between" align="middle">
            <div className="icon icon--arrow-normal-left pages-link__icon" />
            <FormattedMessage id="button.back" />
          </Row>
        </Button>
      </Col>

      <Col className="toggle-column toggle-column--right">
        <Button
          className="btn-primary btn-primary--black"
          block
          onClick={onAccept}
          loading={loading}
        >
          <FormattedMessage id="button.save" />
        </Button>
      </Col>
    </Row>
  );
};
const Toggle: NextPage<OwnProps> = ({
  leftComponent,
  rightComponent,
  showRight,
}): JSX.Element => {
  return (
    <>
      <div
        className={`toggle-contents toggle-contents-${
          showRight ? 'hide' : 'show'
        }`}
      >
        {leftComponent}
      </div>
      <div
        className={`toggle-contents toggle-contents-${
          showRight ? 'show' : 'hide'
        }`}
      >
        {rightComponent}
      </div>
    </>
  );
};

export default Toggle;
